









import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Slider } from 'vue-color';

import Node from '@/models/Node';
import Tag from '@/models/Tag';
import Mutations from '@/store/mutations';
import { SendPacket } from '@/networking/SendPacket';
import ProjectServer from '@/models/ProjectServer';
import { PacketType } from '@/models/Packet';

@Component({
    components:
    {
		Slider
    }
})
export default class ColorSlider extends Vue 
{
    @Prop(Node) readonly node? : Node;
    @Prop(Tag) readonly tag? : Tag;
    @Prop(Boolean) readonly createMode! : Boolean;
    
    get editColor()
    {
        return ((this.node != null) ? this.node.color 
            : ((this.tag != null) ? this.tag.color : { r: 0, g: 0, b: 0 }));
    }
    set editColor(value : any)
    {
        const val = { r: value.rgba.r, g: value.rgba.g, b: value.rgba.b };
        if (this.createMode)
        {
            if (this.node != null && this.node.color !== val)
            {
                this.node.color = val;
            }
            else if (this.tag != null && this.tag.color !== val)
            {
                this.tag.color = val;
            }
        }
        else
        {
            if (this.node != null && this.node.color !== val)
            {
                this.$store.commit(Mutations.updateNodeColor, 
                { 
                    nodeid: this.node.nodeid, 
                    color: val
                });
                SendPacket(PacketType.NodeUpdateColor, { nodeid: this.node.nodeid, color: this.node.color });
            }
            else if (this.tag != null && this.tag.color !== val)
            {
                this.$store.commit(Mutations.updateTagColor, 
                { 
                    tagid: this.tag.tagid, 
                    color: val
                });
                SendPacket(PacketType.TagUpdateColor, { tagid: this.tag.tagid, color: this.tag.color });
            }
        }
    }

    mounted()
    {
        // wizardry to remove the 5th (darkest) swatch value
        let element = document.querySelector('.vc-slider-swatch[data-index="4"]');
        if (element != null)
        {
            element.remove();
        }
    }
}
